import type { ReactNode } from "react";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface InlineConfirmationProps {
  message: ReactNode;
  confirmLabel: string;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const InlineConfirmation = ({
  message,
  confirmLabel,
  isPending,
  onCancel,
  onConfirm,
}: InlineConfirmationProps) => (
  <Stack
    align="start"
    gap={2}
    className="w-full pt-1"
    onClick={(event) => event.stopPropagation()}
  >
    <Text tone="muted">{message}</Text>
    <Stack
      className="w-full"
      direction="row"
      gap={2}
      align="center"
      justify="end"
    >
      <Button
        variant="outline"
        size="xs"
        onClick={onCancel}
        disabled={isPending}
      >
        Cancel
      </Button>
      <Button
        color="danger"
        size="xs"
        onClick={onConfirm}
        disabled={isPending}
        loading={isPending}
      >
        {confirmLabel}
      </Button>
    </Stack>
  </Stack>
);
